// Faixa vermelha fina presa no topo, com o texto rolando sem parar (promoção do celular — AC-258),
// como a do site. O texto se repete para rolar sem emendas; o leitor de tela lê a primeira vez só.
export function PromoBar({ text }: { text: string }) {
  const items = Array.from({ length: 8 }, (_, i) => (
    <span key={i} className="promo-bar__item" aria-hidden={i > 0 ? true : undefined}>
      {text}
    </span>
  ));
  return (
    <div className="promo-bar" data-testid="promo-bar">
      <span className="promo-bar__track">{items}</span>
    </div>
  );
}
